import type { ActivityFilter } from 'state/blotters/common/blotter.model';

export type ScheduleRunStatus = 'Stopped' | 'Running' | 'Paused' | 'Active' | 'Error' | 'Deleted';
export interface Reader {
  email?: string;
  icId: string;
}
export const TRIGGER_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] as const;
export const FREQUENCIES = ['Days', 'BusinessDays', 'Weeks', 'Months'] as const;
export type Day = (typeof TRIGGER_DAYS)[number];
export type FrequencyType = (typeof FREQUENCIES)[number];
export interface Frequency {
  type: FrequencyType;
  value?: number;
}
export type ScheduledQuotesActivity = Exclude<ActivityFilter, 'all'>;
export interface QuoteInfo {
  productType?: string;
  productSubType?: string;
  quoteId?: string;
}

export const SCHEDULED_RUN_OCCURRENCE_STATUSES = ['Success', 'Error', 'PartialSuccess'] as const;
export type ScheduledRunOccurrenceStatus = (typeof SCHEDULED_RUN_OCCURRENCE_STATUSES)[number];

export type ScheduledRunOccurrenceQuote = {
  quoteId?: string;
  pricerRfqId?: string;
  productType?: string;
  productSubType?: string;
  instrumentContractName?: string;
  instrumentName?: string;
  wrapper?: string;
};

export type ScheduledRunOccurrence = {
  occurrenceDate?: string;
  occurrenceId?: string;
  errorsCount?: number;
  message?: string;
  quotes: readonly ScheduledRunOccurrenceQuote[];
  quotesCount?: number;
  runId?: string;
  scheduleId?: string;
  status?: ScheduledRunOccurrenceStatus;
};
